var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-checkmark_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.877 13.161a1.3 1.3 0 01-1.04-.552l-3.64-5.2a1.302 1.302 0 112.132-1.495l2.535 3.62 5.68-8.781A1.302 1.302 0 0112.73 2.17l-6.76 10.4a1.3 1.3 0 01-1.073.591h-.02z",
    fill: "#5CB147"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-checkmark_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h13v14H0z"
  })))));
}

export default SvgIconCheckmark;